export const PARTNERS_STATS_EVENTS = {
  PARTNERS_STATS_AMOUNT: 'partners-stats-amount',
  PARTNERS_STATS_COUNT: 'partners-stats-count',
  PARTNERS_STATS_EARNINGS: 'partners-stats-earnings',
};

export const PARTNERS_PRODUCT_FILTER_EVENTS = {
  PARTNERS_PRODUCT_FILTER_ALL: 'partners-filter-product-all',
  PARTNERS_PRODUCT_FILTER_OSAGO: 'partners-filter-product-osago',
  PARTNERS_PRODUCT_FILTER_GREEN_CARD: 'partners-filter-product-green-card',
  PARTNERS_PRODUCT_FILTER_TOURISM: 'partners-filter-product-tourism',
  PARTNERS_PRODUCT_FILTER_HOME: 'partners-filter-product-home',
  PARTNERS_PRODUCT_FILTER_EXTERNAL: 'partners-filter-product-external',
  PARTNERS_PRODUCT_FILTER_MINI_KASKO: 'partners-filter-product-mini-kasko',
  PARTNERS_PRODUCT_FILTER_PETS: 'partners-filter-product-pets',
};

export const PARTNERS_PERIOD_FILTER_EVENTS = {
  PARTNERS_PERIOD_FILTER_CURRENT_MONTH: 'partners-filter-period-current-month',
  PARTNERS_PERIOD_FILTER_MONTH: 'partners-filter-period-month',
  PARTNERS_PERIOD_FILTER_WEEK: 'partners-filter-period-week',
  PARTNERS_PERIOD_FILTER_DAY: 'partners-filter-period-day',
  PARTNERS_PERIOD_FILTER_DATES_RANGE: 'partners-filter-period-dates-range',
};
